










import { Component, Prop, Vue } from 'vue-property-decorator'

import NoRetoggleCollapse from '@/components/NoRetoggleCollapse.vue'

@Component({
  components: {
    NoRetoggleCollapse,
  },
  inheritAttrs: false,
})
export default class OptionAccordion extends Vue {
  @Prop({
    default: 'amount',
    validator: (v: string) => v === 'amount' || v === 'payment',
  })
  variant!: 'amount' | 'payment'
}
